module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 25 24.64"
    }
  }, [_c('defs'), _c('g', {
    attrs: {
      "id": "Слой_2",
      "data-name": "Слой 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Слой_1-2",
      "data-name": "Слой 1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M15.05,17l-2.29-.72-2.91-.89a4,4,0,0,1-1.67-.91,2,2,0,0,1-.67-1.34,1.5,1.5,0,0,1,.22-.92c.8-1.39,1.6-2.79,2.41-4.18l.16-.31L8.05,7.37c-.15,0-.22.07-.3.15L4.94,10.11a1.35,1.35,0,0,1-2.16-.45,1.32,1.32,0,0,1,.31-1.49Q5,6.39,6.93,4.63a1.67,1.67,0,0,1,1.44-.38L13.59,5a4.91,4.91,0,0,1,1.53.5,2.51,2.51,0,0,1,.93,3.86c-.54.74-1.16,1.43-1.74,2.15-.37.47-.74.94-1.12,1.39-.14.17-.07.19.09.24l4.87,1.54a1.55,1.55,0,0,1,1.11,1.66A1.12,1.12,0,0,1,19,17c-.89,1-1.86,1.95-2.83,2.89-.62.61-1.25,1.21-1.88,1.81a1.35,1.35,0,1,1-1.89-1.92c.8-.83,1.6-1.65,2.4-2.49C14.85,17.21,14.94,17.11,15.05,17Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M7,13.77A3.82,3.82,0,0,0,9.45,15.9c.18.06.2.12.13.29-.47,1-.92,2.07-1.38,3.11a1.6,1.6,0,0,1-.45.55c-1.06,1-2.19,1.86-3.32,2.75-.71.57-1.44,1.13-2.16,1.69A1.35,1.35,0,1,1,.57,22.2L5,18.5a1,1,0,0,0,.31-.44l1.56-4A2.41,2.41,0,0,1,7,13.77Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M17.12,6.93c.83.58,1.64,1.14,2.43,1.72.19.14.29.11.45,0,.91-.85,1.82-1.7,2.74-2.54a1.34,1.34,0,0,1,2.08.32A1.31,1.31,0,0,1,24.63,8c-1.27,1.19-2.54,2.39-3.84,3.54a1.88,1.88,0,0,1-1.64.52,1.31,1.31,0,0,1-.57-.24c-.7-.5-1.39-1-2.09-1.47-.16-.11-.22-.17-.07-.36a3.16,3.16,0,0,0,.73-2.87S17.14,7,17.12,6.93Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M17.28,5.73a2.85,2.85,0,0,1-2.85-2.91,2.87,2.87,0,1,1,2.85,2.91Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3de78720","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/templates/icons/manRunning.vue
// module id = b61de4ffb8f39131279d
// module chunks = 89